import { FAILED_TO_STORE_TAG, STORED_TAG, STORING_TAG } from '../../../constants';
import fetch from '../../../utils/fetch-json';

export const submitTag =
    ({ projectId, tag }) =>
    ({ dispatch, getState }) => {
        const state = getState();
        const url = `${state.baseURL}/api/private/project/${projectId}/organizationTag`;

        dispatch({ type: STORING_TAG });

        return fetch({
            url,
            options: {
                method: 'POST',
                body: { tag },
            },
            dispatch,
            getState,
        })
            .then(() => {
                dispatch({ type: STORED_TAG });
            })
            .catch(() => {
                dispatch({ type: FAILED_TO_STORE_TAG });
            });
    };
